export default __webpack_public_path__ + "images/0x3ad707da309f3845cd602059901e39c4dcd66473.png";